import { render, staticRenderFns } from "./ProviderDetail.vue?vue&type=template&id=5dd1ff12&scoped=true"
import script from "./ProviderDetail.vue?vue&type=script&lang=js"
export * from "./ProviderDetail.vue?vue&type=script&lang=js"
import style0 from "./ProviderDetail.vue?vue&type=style&index=0&id=5dd1ff12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd1ff12",
  null
  
)

export default component.exports